export const logTime = (label, startTime) => {
    const diff = process.hrtime(startTime);
    const timeInMs = diff[0] * 1000 + diff[1] / 1e6;
    const currentTime = new Date().toISOString();
    console.log(`${currentTime} | ${label} | ${timeInMs.toFixed(2)} ms`);
};
